/**
 * @param { String } date - timeStamp в toLocaleString() - 03.02.2023, 15:35:26
 * @returns { Number } - timeStamp * 1000
 */
export default function makeTimeStamp(date) {
    let dateParts = date.split(', ')

    let [day, month, year] = dateParts[0].split('.')
    let [hour, minute, second] = dateParts[1].split(':')

    return new Date(year, month - 1, day, hour, minute, second).getTime()
}